import { invert } from 'lodash-es';
import { TEAM_COMMENT_TYPE } from '../../../components/StatelessComponent/SingleFilter/TeamCommentFilter/TeamCommentFilterType';
import type { IntermediateFormat } from '../../../domains/global-filters/model/IntermediateFormat';
import type { QueryFormatFilter } from '../../../domains/global-filters/model/QueryFormat';
import { QueryKeyEnum } from '../../../domains/global-filters/model/QueryFormat';
import * as RadioConverter from './GenericConverter/RadioConverter';

const queryValueByUiValue: Record<TEAM_COMMENT_TYPE, string> = {
  [TEAM_COMMENT_TYPE.WITH]: 'true',
  [TEAM_COMMENT_TYPE.WITHOUT]: 'false',
};

const uiValueByQueryValue = invert(queryValueByUiValue) as Record<string, TEAM_COMMENT_TYPE>;

export function fromUiToQueryFormat(uiValue: TEAM_COMMENT_TYPE): QueryFormatFilter {
  return RadioConverter.fromUiToQueryFormat(uiValue, QueryKeyEnum.commented, queryValueByUiValue);
}

export function fromIntermediateToUiFormat(
  intermediateValue: IntermediateFormat,
): TEAM_COMMENT_TYPE {
  return RadioConverter.fromIntermediateToUiFormat(intermediateValue, uiValueByQueryValue);
}
